import classNames from 'classnames';
import React from 'react';
import FieldFooter from '../../components/FieldFooter/FieldFooter';
import IFieldRender from '../../types/FieldRender';
import Field from '../Field/Field';
import SegmentedControl from '../SegmentedControl/SegmentedControl';
import ISegmentedControlFormFieldProps from './SegmentedControlFormFieldProps';

const SegmentedControlFormField = <T, FormType extends { [field: string]: any } = {}>({
  form,
  name,
  validations,
  shouldValidateOnUpdate,
  className,
  onChange,
  ...other
}: ISegmentedControlFormFieldProps<T, FormType>) => {
  function renderControl(fieldRender: IFieldRender<T>) {
    const value = form.state.data[name];

    function onContrlChange(val: T) {
      fieldRender.handleChange(val, onChange);
    }

    return (
      <>
        <SegmentedControl value={value} onChange={onContrlChange} {...other} />
        <FieldFooter errorMessage={fieldRender.errorMessage} hasError={fieldRender.hasError} />
      </>
    );
  }

  return (
    <Field
      form={form}
      name={name}
      shouldValidateOnUpdate={shouldValidateOnUpdate}
      validations={validations}
      className={classNames('segmented-control-form-field', className)}
      render={renderControl}
    />
  );
};

SegmentedControlFormField.defaultProps = {
  sizing: 'fixed',
  disabled: false,
};

export default SegmentedControlFormField;
